var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('img',{class:[_vm.$style.img, 'logo'],attrs:{"width":"1200","height":"900","src":require("../../../../assets/logo.svg"),"alt":"Логотип Альянса"}})])}
var staticRenderFns = []

export { render, staticRenderFns }